<template>
    <v-container fluid fill-height class="flex-column gradient-container">
        <v-container>
            <v-row width="100%">
                <v-col cols="12" class="text-left mb-6">
                    <router-link to="/">
                        <img src="@/assets/images/claass-logo-white-without-betta.svg" class="class-logo" />
                    </router-link>
                </v-col>
                <v-col cols="12" class="mt-4">
                    <div class="text-center white--text">
                        <template v-if="passwordChanged">
                            <div class="display-3 my-6" v-text="$t('ForgotPasswordFinishTitle')"></div>
                            <div class="headline font-weight-medium" v-text="$t('ForgotPasswordFinishDescription')"></div>
                            <v-btn
                                depressed
                                rounded
                                color="white"
                                class="mt-8 mt-lg-12"
                                to="/login"
                                v-text="$t('LogIn')"
                            ></v-btn>
                        </template>
                        <template v-else>
                            <div class="display-3 mt-6 mb-12" v-text="$t('ForgotPasswordNewPasswordTitle')"></div>
                            <v-row justify="center">
                                <v-col cols="12" md="6" lg="4">
                                    <form @submit.prevent="resetPassword">
                                        <v-text-field
                                            dark
                                            rounded
                                            outlined
                                            autofocus
                                            required
                                            validate-on-blur
                                            v-model="resetPasswordForm.password"
                                            :rules="resetPasswordRules.password"
                                            color="white"
                                            class="custom-white-inputs"
                                            type="password"
                                            :label="$t('Password')"
                                        ></v-text-field>
                                        <v-text-field
                                            dark
                                            rounded
                                            outlined
                                            required
                                            validate-on-blur
                                            v-model="resetPasswordForm.confirmPassword"
                                            :rules="resetPasswordRules.confirmPassword"
                                            color="white"
                                            class="custom-white-inputs"
                                            type="password"
                                            :label="$t('ConfirmPassword')"
                                        ></v-text-field>
                                        <v-btn
                                            depressed
                                            rounded
                                            color="white"
                                            type="submit"
                                            :loading="resetingPasswordRequest"
                                            :disabled="resetingPasswordRequest || !isResetPasswordFormValid"
                                        >{{ $t('Save') }}</v-btn>
                                    </form>
                                </v-col>
                            </v-row>
                        </template>                 
                    </div>
                </v-col>
            </v-row>        
        </v-container>
    </v-container>
</template>

<script>
    export default {
        name: 'passwordForgot',
        data () {
            const defaultResetPasswordForm = Object.freeze({
                password: '',
                confirmPassword: ''
            })
            return {
                token: '',
                resetPasswordForm: Object.assign({}, defaultResetPasswordForm),
                resetPasswordRules: {
                    password: [                        
                        val => {
                            const pattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
                            return pattern.test(val)
                        }
                    ],
                    confirmPassword: [
                        val => (val || '').length > 0,
                        val => val === this.resetPasswordForm.password
                    ]
                },
                resetingPasswordRequest: false,
                passwordChanged: false
            }
        },
        mounted() {
            this.recaptcha();
        },
        destroyed() {
            this.$nextTick(() => {
                this.$recaptchaInstance.hideBadge()
            })
        },
        computed: {
            isResetPasswordFormValid() {
                if(
                    this.resetPasswordForm.password &&
                    this.resetPasswordForm.confirmPassword
                ) {
                    const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
                    if(
                        passwordPattern.test(this.resetPasswordForm.password) && 
                        this.resetPasswordForm.password === this.resetPasswordForm.confirmPassword
                    ) {
                        return true
                    }
                    return false
                }
                return false
            }
        },
        beforeMount() {
            this.token = this.$route.params.token
        },
        methods: {
            async recaptcha() {
                await this.$recaptchaLoaded()
                this.$recaptchaInstance.showBadge()
            },
            resetPassword() {
                this.resetingPasswordRequest = true
                this.$recaptcha().then((gToken) => {
                    const data = {
                        token: this.token,
                        newPassword: this.resetPasswordForm.password,
                        recaptcha: gToken
                    }
                    this.axios.post('/User/RessetPassword', data)
                    .then(response => {
                        this.resetingPasswordRequest = false
                        this.passwordChanged = true
                    })
                    .catch(error => {
                        const snackbar = {
                            show: true,
                            message: error.response.data.message
                        }
                        this.$EventBus.$emit('snackbar', snackbar)
                        this.resetingPasswordRequest = false
                    })

                })

            }
        }
    }
</script>

<style lang="scss">
.gradient-container{
    background: rgb(86,125,251);
    background: -moz-linear-gradient(top, rgba(86,125,251,1) 0%, rgba(56,217,253,1) 100%);
    background: -webkit-linear-gradient(top, rgba(86,125,251,1) 0%,rgba(56,217,253,1) 100%);
    background: linear-gradient(to bottom, rgba(86,125,251,1) 0%,rgba(56,217,253,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#567dfb', endColorstr='#38d9fd',GradientType=0 );
    .class-logo{
        height: 75px;
    }
}
.custom-white-inputs{
    &.theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset{
        color: #fff;
    }
}
</style>